module.exports = __webpack_public_path__ + "img/lottedfs.b327df15.png";